// src/Components/ReservationPayModal/ReservationPayModal.js
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { TabView, TabPanel } from 'primereact/tabview';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { InputSwitch } from 'primereact/inputswitch';

import { Grid } from '@mui/material';


import iconResponsibleWarning from '../../Assets/Images/iconResponsibleWarn.svg';
import notfoundIcon from '../../Assets/Images/notfoundIcon.png';

import visa_icon from '../../Assets/Images/visa_icon.svg';
import mastercard_icon from '../../Assets/Images/mastercard_icon.svg';
import creditcard_icon from '../../Assets/Images/creditcard_icon.svg';

import * as AppActions from '../../Store/Actions/App';
import * as OrderActions from '../../Store/Actions/Order';

import {
  maskCreditcard,
  maskCardExpiry,
  maskCPF,
  getCardBrand,
  validarNumeroCartao,
  validarNomeCartao,
  validarValidadeCartao,
  formatNumberCurrency
} from '../../Components/Utils';

const ReservationPayModal = (props) => {
  const {
    // controle de abertura/fechamento
    payDialog,
    setPayDialog,

    // dados já abertos na modal “mãe”
    reservationData,            // << recebido do pai (obrigatório)
    selectedReservation,        // opcional
    bookingId,                  // opcional

    // callbacks para recarregar dados no pai
    onReloadData,
    onReloadDataList,
    retrieveReservation,
    executeRetrieveOrder,

    // alerts do pai (mesmo esquema do cancel)
    setAlert,
    setAlertTitle,
    setAlertBody,

    // actions
    payBooking,                 // já existe em Order.js
    key
  } = props;

  const isOpen = !!payDialog;
  const toast = React.useRef(null);

  const blockPayment = (reservationData?.responsiblePayer?.isOneOfGuests === false && reservationData?.applyPaymentRestrictions === true) ? true : false;
  const paymentRestrictions = (reservationData?.applyPaymentRestrictions === true) ? true : false;

  // Mapeamento das marcas para os ícones
  const cardIcons = {
    visa: visa_icon,
    mastercard:mastercard_icon,
    creditcard: creditcard_icon,
    amex: creditcard_icon,
    elo: creditcard_icon,
    hipercard: creditcard_icon,
    diners: creditcard_icon,
    discover: creditcard_icon
  };

  // ------------ dados base vindos da reserva ------------
  const id =
    selectedReservation?.reservationId ||
    bookingId ||
    reservationData?.id;

  const usdRate = Number(
    reservationData?.exchangeRates?.usd?.value ||
    reservationData?.totals?.payNowConvertedExchangeRate ||
    5.0
  );

  const payNowUSD = Number(reservationData?.totals?.payNow || 0); // valor a pagar agora (USD)
  const methodDefaultLabel = reservationData?.latestPayment?.methodLabel || 'Cartão de crédito';

  // comissão: usa o que vier da reserva
/*  const commissionDefaultPct = Number(
    reservationData?.commission?.advanceComissionPercentage ??
    reservationData?.commission?.percentage?.cc ??
    0
  );*/

 const commissionDefaultPct = React.useMemo(() => {
   const adv = Number(reservationData?.commission?.advanceComissionPercentage);
   const cc  = Number(reservationData?.commission?.percentage?.cc);
   const num = (Number.isFinite(adv) && adv > 0) ? adv
             : (Number.isFinite(cc)  && cc  > 0) ? cc
             : 0;
   return num;
 }, [reservationData,isOpen]);


  const payer = reservationData?.responsiblePayer || {};
  const payerCPF = payer?.document?.type === 'CPF' ? payer?.document?.number : '';

  // ------------ estados da interface ------------
  const [activeIndex, setActiveIndex] = React.useState(0); // 0: cartão | 1: pix (desabilitado)
  const [loading, setLoading] = React.useState(false);

  const [advanceComission, setAdvanceComission] = React.useState(false);
  const [advanceComissionPercentage, setAdvanceComissionPercentage] = React.useState(commissionDefaultPct);
  const [advanceComissionAmountUSD, setAdvanceComissionAmountUSD] = React.useState(0);

  const [installmentsOptions, setInstallmentsOptions] = React.useState([]);
  const [form, setForm] = React.useState({
    cardNumber: '',
    cardBrand: 'creditcard',
    cardHolderName: '',
    cardExpiry: '',
    cardCvv: '',
    cardHolderCpf: payerCPF || '',
    installments: null,
    installmentsLabel: null
  });

  // ------------ helpers ------------
  const normalizeDigits = (v = '') => String(v).replace(/\D/g, '');
  const normalizeCard = (v = '') => String(v).replace(/\s+/g, '');

  const toTitle = (s='') => s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : s;
  const mapBrandForApi = (raw) => {
    const b = String(raw || '').toLowerCase();
    const map = { visa:'Visa', mastercard:'Master', amex:'Amex', elo:'Elo', hipercard:'Hipercard', diners:'Diners', discover:'Discover', creditcard:'Unknown' };
    return map[b] || toTitle(b);
  };

    const computeInstallments = (useUSD) => {
    const minimumPerInstallmentUSD = 25;
    const opts = [];
    for (let i = 1; i <= 12; i++) {
        const per = useUSD / i;
        if (per >= minimumPerInstallmentUSD) {
        const perBRL = per * usdRate;
        opts.push({
            label: `${i}x sem juros de ${formatNumberCurrency(perBRL, 'BRL')}`,
            value: i
        });
        }
    }
    setInstallmentsOptions(opts);
    setForm((p) => ({ ...p, installments: null, installmentsLabel: null }));
    };

  const totalUSD = payNowUSD || 0;
  const commissionUSD = (totalUSD * (advanceComissionPercentage || 0)) / 100;
  const totalUSDNoCommission = Math.max(totalUSD - commissionUSD, 0);

  const totalBRL = totalUSD * usdRate;
  const totalBRLNoCommission = totalUSDNoCommission * usdRate;
  const commissionBRL = commissionUSD * usdRate;

  // recomputa comissão quando muda toggle/pct
  React.useEffect(() => {
    setAdvanceComissionAmountUSD(commissionUSD);
  }, [advanceComission, advanceComissionPercentage, totalUSD]);

  
// Recalcula parcelas quando os parâmetros relevantes mudarem
React.useEffect(() => {
  const baseUSD = advanceComission ? totalUSDNoCommission : totalUSD;
  computeInstallments(baseUSD);
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [advanceComission, advanceComissionPercentage, totalUSD, usdRate]);


  const handleField = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const resetState = () => {
    setActiveIndex(0);
    setLoading(false);
    setAdvanceComission(false);
    setAdvanceComissionPercentage(commissionDefaultPct);
    setAdvanceComissionAmountUSD(0);
    setInstallmentsOptions([]);
    setForm({
      cardNumber: '',
      cardBrand: 'creditcard',
      cardHolderName: '',
      cardExpiry: '',
      cardCvv: '',
      cardHolderCpf: payerCPF || '',
      installments: null,
      installmentsLabel: null
    });
  };

  const close = () => {
    resetState();
    setPayDialog(false);
  };

/*  React.useEffect(() => {
        
    if (!isOpen) resetState();

    if (isOpen) {
        const baseUSD = advanceComission ? totalUSDNoCommission : totalUSD;
        computeInstallments(baseUSD);
    }

  }, [isOpen]);*/

 React.useEffect(() => {

   if (!isOpen) return;

   // 1) realinha todos os estados derivados dos dados atuais
   const pct = Number(commissionDefaultPct || 0);
   const totalUSD = Number(reservationData?.totals?.payNow || 0);
   const commissionUSDNow = (totalUSD * pct) / 100;

   setActiveIndex(0);
   setAdvanceComission(false);
   setAdvanceComissionPercentage(pct);
   setAdvanceComissionAmountUSD(commissionUSDNow);
   setForm(p => ({
     ...p,
     cardNumber: '',
     cardBrand: 'creditcard',
     cardHolderName: '',
     cardExpiry: '',
     cardCvv: '',
     cardHolderCpf: (reservationData?.responsiblePayer?.document?.type === 'CPF'
                      ? reservationData?.responsiblePayer?.document?.number
                      : '') || '',
     installments: null,
     installmentsLabel: null
   }));

   // 2) (re)calcula parcelamento com os valores atualizados
   computeInstallments(totalUSD);
 }, [isOpen, commissionDefaultPct, reservationData]);


     // cria um voucher básico (opcional, mas ajuda o back a mandar PDF/email)
    const buildVoucherInfo = () => {
        const room0 = reservationData?.hotel?.rooms?.[0] || {};
        const hotel = reservationData?.hotel || {};
        const dest = reservationData?.destination || {};
        const totals = reservationData?.totals || {};
        const period = reservationData?.booking?.period || {};
        const payer = reservationData?.responsiblePayer || {};

        // Fallbacks úteis
        const bookingNumber =
            reservationData?.booking?.reservationCode ||
            reservationData?.internalCode ||
            String(reservationData?.id || '');

        const deadlineDisplay =
            reservationData?.booking?.deadlines?.freeCancelDateDisplay ||
            room0?.cancelPolicy?.untilDisplay ||
            '—';

        const guestsLabel =
            room0?.guestsSummary ||
            (Array.isArray(reservationData?.guests) && reservationData.guests.length
            ? `${reservationData.guests.length} hóspedes`
            : '—');

        const roomExtra =
            Array.isArray(room0?.extras) && room0.extras.length
            ? room0.extras.join(', ')
            : 'Nenhum extra incluído';

        // >>>> JSON EXATAMENTE NO FORMATO ESPERADO PELO BACK <<<<
        return {
            hotel_name: `${hotel?.name || ''}${dest?.display ? ` - ${dest.display}` : ''}`.trim() || '—',
            booking_period: period?.display || '—',
            booking_number: bookingNumber,
            hotel_address: [hotel?.address, dest?.city].filter(Boolean).join(', ') || '—',
            hotel_contact: { tel: '', email: '', site: '' }, // objeto é truthy, ok
            hotel_checkin: hotel?.checkinTime || '15:00:00',
            hotel_checkout: hotel?.checkoutTime || '12:00:00',
            cancellation_deadline: deadlineDisplay,
            cancellation_policy: room0?.cancelPolicy?.text || '- não definido -',
            total_amount: totals?.displayTotal || totals?.payNowDisplay || '0',
            total_booking: totals?.payNowDisplay || totals?.displayTotal || '0',
            total_local: totals?.payAtPropertyDisplay || '0', // <- evita "" (falsy)
            room: {
                // chaves exigidas:
                title: room0?.name || '- não definido -',                 // <- OBRIGATÓRIA
                room_name: room0?.name || '- não definido -',             // (se o template usar)
                room_hosts_label: guestsLabel || '- não definido -',             // <- OBRIGATÓRIA
                room_responsible_name: payer?.fullName || '- não definido -',
                room_extra: roomExtra || '- não definido -'
            },
            bookingPaymentResponsible: {
                completeName: payer?.fullName || '- não definido -',
                email: payer?.email || '- não definido -',
                mobilePhone: payer?.phone || '- não definido -'
            }
        };
    };


  // ------------ ação principal (pagar) ------------
  const handlePay = async () => {
    try {
      if (activeIndex !== 0) {
        toast.current?.show({ severity: 'warn', summary: 'Forma indisponível', detail: 'PIX em breve. Use Cartão de crédito.', life: 6000 });
        return;
      }
      // validações
      const numberRaw = normalizeCard(form.cardNumber);
      const holderRaw = (form.cardHolderName || '').trim();
      const expRaw = (form.cardExpiry || '').trim();
      const cvvRaw = normalizeDigits(form.cardCvv);
      const cpfRaw = normalizeDigits(form.cardHolderCpf);

      if (!validarNumeroCartao(numberRaw)) {
        toast.current?.show({ severity: 'warn', summary: 'Cartão', detail: 'Número do cartão inválido.', life: 6000 });
        return;
      }
      if (!validarNomeCartao(holderRaw)) {
        toast.current?.show({ severity: 'warn', summary: 'Cartão', detail: 'Nome do portador inválido.', life: 6000 });
        return;
      }
      if (!validarValidadeCartao(expRaw)) {
        toast.current?.show({ severity: 'warn', summary: 'Cartão', detail: 'Validade inválida. Use MM/AA ou MM/AAAA.', life: 6000 });
        return;
      }
      if (!cvvRaw || cvvRaw.length < 3) {
        toast.current?.show({ severity: 'warn', summary: 'Cartão', detail: 'CVV inválido.', life: 6000 });
        return;
      }
      if (!form.installments) {
        toast.current?.show({ severity: 'warn', summary: 'Parcelamento', detail: 'Selecione o número de parcelas.', life: 6000 });
        return;
      }
      if (payer?.isForeigner !== true && !cpfRaw) {
        toast.current?.show({ severity: 'warn', summary: 'Documento', detail: 'Informe o CPF do portador.', life: 6000 });
        return;
      }

    // bandeira
    const detected = getCardBrand(numberRaw);
    const brandApi = mapBrandForApi(detected);

    // 4.1) Verificsa se a bandeira do cartão é aceita
    const acceptedCreditcardBrands = ['Visa', 'Master'];
    if (!acceptedCreditcardBrands.includes(brandApi)) {
      toast.current?.show({ severity: 'warn', summary: 'Bandeira não aceita', detail: 'Bandeira do cartão não aceita. Confira e tente novamente.', life: 6000 });
      return;
    }       

    // --------- Cálculos de valores ---------
    const pct = Number(advanceComissionPercentage || 0);

    // Total da reserva (USD/BRL)
    const totalUSD = payNowUSD || 0;
    const totalBRL = totalUSD * usdRate;

    // Comissão (sempre calculada para registro)
    const commissionUSD = (totalUSD * pct) / 100;
    const commissionBRL = commissionUSD * usdRate;

    // Valor a cobrar AGORA
    // - Se antecipar comissão: cobra total - comissão
    // - Se NÃO antecipar: cobra total integral (a comissão será paga depois)
    const chargeUSD = advanceComission ? Math.max(totalUSD - commissionUSD, 0) : totalUSD;
    const chargeBRL = chargeUSD * usdRate;

    // --------- Montagem do payload (sempre manda comissionAmount) ---------
    const payload = {
        customer: {
            name: (payer?.fullName || '').trim(),
            identity: cpfRaw || '',
            email: (payer?.email || '').trim()
        },
        payment: {
            originalAmount: chargeUSD.toFixed(2),       // valor a cobrar agora (USD)
            originalCurrency: 'USD',
            exchangeRateUsed: usdRate,
            convertedCurrency: 'BRL',
            amount: chargeBRL.toFixed(2),               // valor a cobrar agora (BRL)
            advanceCommission: !!advanceComission,      // toggle apenas indica SE antecipa
            comissionAmount: commissionBRL.toFixed(2),  // SEMPRE mande o valor da comissão
            comissionAmountCalculated: commissionBRL,   // número puro
            comissionPercentage: pct,                   // SEMPRE mande o percentual
            paymentMethod: 'cc',
            installments: Number(form.installments || 1),
            creditCard: {
                cardNumber: numberRaw,
                holder: holderRaw,
                expirationDate: expRaw, // MM/AA ou MM/AAAA
                securityCode: cvvRaw,
                brand: brandApi
            }
        },
        bookingVoucherInfo: buildVoucherInfo(),
        bookingId: Number(id)
    };

      setLoading(true);
      const res = await payBooking(payload);

      // sucesso
      if (res?.success) {
        setAlertTitle('Tudo certo! Pagamento realizado!');
        setAlertBody('O pagamento da reserva foi realizado com sucesso! A reserva foi atualizada com os dados mais recentes. O voucher será enviado por e-mail no email de confirmação.');
        setAlert(true);
        close();

        if (typeof onReloadData === 'function') onReloadData();
        if (typeof onReloadDataList === 'function') onReloadDataList();
        return;
      }

      // pendente (timeout do gateway etc.)
      if (res?.data?.pending) {
        setAlertTitle('Pagamento pendente');
        setAlertBody(res?.error || 'O pagamento ficou pendente no provedor. Aguarde o processamento e atualize a reserva em alguns minutos.');
        setAlert(true);
        // mantemos a modal fechada para evitar duplicidade
        close();
        if (typeof onReloadData === 'function') onReloadData();
        if (typeof onReloadDataList === 'function') onReloadDataList();
        return;
      }

    // --- Erro normalizado pelo action ---
    const errKey = String(res?.errorKey || res?.details?.errorCode || '');
    const status = res?.status || null;
    const userMsg =
      res?.userMessage ||
      'Não foi possível concluir o pagamento. Tente novamente em instantes.';

        // Se 40901/40902: recarrega dados (status mudou durante o processo)
        if (status === 409 && (errKey === '40901' || errKey === '40902')) {

            
            setAlertTitle('Ops! Temos um problema!');
            setAlertBody('O pagmento da reserva mudou de status durante o processo e não é possível prosseguir. Atualizamos as informações da reserva. Verifique e tente novamente, se for o caso.');
            setAlert(true);
            close();

            if (typeof onReloadData === 'function') {
                onReloadData();
                onReloadDataList();
            } 
            return;
        }

      toast.current?.show({ severity: 'error', summary: 'Falha no pagamento', detail: userMsg, life: 10000 });


    } catch (err) {

        // --- Erro via exceção (rede/timeout/etc.) ---
        const status = err?.response?.status || null;
        const code =
        String(err?.response?.data?.errorCode || err?.response?.data?.code || '');
        const userMsg =
        err?.response?.data?.userMessage ||
        err?.response?.data?.errorMessage ||
        err?.message ||
        'Não foi possível concluir o pagamento no momento.';

        // Se 40901/40902 mesmo em exceção: recarrega
        if (status === 409 && (code === '40901' || code === '40902')) {
            setAlertTitle('Ops! Temos um problema!');
            setAlertBody('O pagamento da reserva mudou de status durante o processo e não é possível prosseguir. Atualizamos as informações da reserva. Verifique e tente novamente, se for o caso.');
            setAlert(true);
            close();

            if (typeof onReloadData === 'function') {
                onReloadData();
                onReloadDataList();
            } 

            return;
        }

        toast.current?.show({ severity: 'error', summary: 'Erro no pagamento', detail: userMsg, life: 10000 });

    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      header="Pagamento da reserva"
      visible={isOpen}
      style={{ width: '760px', maxWidth: '95vw', height:"90vh" }}
      modal
      onHide={() => !loading && close()}
      key={key || 'reservation-pay-modal'}
    >
      <div className="p-fluid" style={{ display: 'flex', flexDirection: 'column', gap: 12, height:blockPayment === true ?  "100%" : '', alignItems:blockPayment === true ?  'center' : '', justifyContent: blockPayment === true ?  'center' : ''}}>

      {(blockPayment === true) &&
      <>
      <div className="flex-column justify-content-center align-items-center" style={{width:"80%",gap:"1rem",textAlign:"center",padding:"1rem"}}>
        <div><img src={notfoundIcon} style={{width:"100px",height:"auto"}} /></div>
        <div className="bookingDetails_wrapper_item_label">Não é possível realizar o pagamento dessa reserva.</div>
        <div className="advanceComissionWarning" style={{background:"#fff3cd",border:"1px solid #ffecb5",padding:"0.5rem",borderRadius:8,color:"#7a6b3cff",fontSize:"0.875rem"}}>Atenção: O responsável pelo pagamento da reserva não é um dos hóspedes. <br /><br />Para realizar o pagamento dessa reserva entre em contato com o suporte para liberação do pagamento ou alteração do responsável pelo pagamento.</div>
      </div>
      </>
      }

      {(blockPayment === false) &&
      <>
        {/* Resumo topo */}
        <div style={{ background: '#f8f9fa', border: '1px solid #eee', borderRadius: 8, padding: 12 }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, fontSize: 13 }}>
            <span><strong>Reserva:</strong> #{id} | </span>
            <span><strong>Hotel:</strong> {reservationData?.hotel?.name} | </span>
            <span><strong>Período:</strong> {reservationData?.booking?.period?.display} | </span>
            <span><strong>Forma de pagamento:</strong> {methodDefaultLabel}</span>
          </div>
          <div style={{ marginTop: 8 }}>
            <div style={{ fontSize: 14 }}>
              {advanceComission ? (
                <>
                  <div><strong>Valor total:</strong> {formatNumberCurrency(totalBRLNoCommission, 'BRL')}</div>
                  <div style={{ color: '#b42318', fontWeight: 600 }}>
                    Comissão antecipada: {formatNumberCurrency(commissionBRL, 'BRL')} ({advanceComissionPercentage}%)
                  </div>
                </>
              ) : (
                <div><strong>Valor total:</strong> {formatNumberCurrency(totalBRL, 'BRL')}</div>
              )}
              <div style={{ color: '#878787', fontSize: 12 }}>
                inclui impostos e taxas • câmbio: {usdRate?.toFixed(2)} BRL/USD
              </div>
            </div>
          </div>
        </div>

        {/* Show warning message */}
        {!paymentRestrictions && (
          <div className="advanceComissionWarning" style={{ background: "#fff3cd", border: "1px solid #ffecb5", padding: "0.5rem", borderRadius: 8, color: "#8b7b4bff", fontSize: "0.875rem" }}>
            Atenção: O responsável pelo pagamento da reserva não é um dos hóspedes, porém, foi habilitado o pagamento da reserva pela gestão do sistema.
          </div>
        )}

        {/* Antecipar comissão */}
        <div className="field" style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop:"0", width:"100%",padding:"0.5rem" }}>
          <InputSwitch
            inputId="advanceComission"
            checked={advanceComission}
            onChange={(e) => setAdvanceComission(!!e.value)}
            disabled={loading || !advanceComissionPercentage}
          />
          <label htmlFor="advanceComission">
            Antecipar <strong>{formatNumberCurrency(commissionBRL, 'BRL')}</strong> referente aos <strong>{advanceComissionPercentage || 0}%</strong> de comissão da agência
          </label>

        </div>

        <div className="flex-row justify-content-start align-items-center w100" style={{gap:"1rem",marginTop:"0rem",padding:"0.5rem"}}>
            <img src={iconResponsibleWarning} alt="Aviso de antecipação de comisssão" style={{width:"2.5rem",height:"auto"}} />
            <div className="advanceComissionWarningSmall" style={{fontSize:"0.75rem"}}>Ao retirar a comissão da agência do valor final de pagamento a mesma deve ser cobrada pela agência diretamente do cliente final.</div>
        </div>        

        {/* Tabs de pagamento */}
        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
          <TabPanel header="Cartão de crédito">

            <Grid container spacing={2} style={{width:"100%",padding:"0.5rem"}}>

                <Grid item xs={12} sm={6}>
                    {/* Número */}
                    <div className="field" style={{ position: 'relative', flex:1}}>
                    <label>Número do cartão <span className="requiredField">*</span></label>
                    <InputText
                        value={form.cardNumber}
                        onChange={(e) => {
                                
                            const raw = e.target.value.replace(/\D/g, '');
                            const masked = maskCreditcard(raw);
                            handleField('cardNumber', masked);
                           
                            // detecta bandeira no input
                             //const brand = getCardBrand(raw);
                           // handleField('cardBrand', brand || 'creditcard');

                            // 🔍 Detectar bandeira
                            if (/^4/.test(raw)) handleField('cardBrand', 'visa');
                            else if (/^5[1-5]/.test(raw)) handleField('cardBrand', 'mastercard');
                            else if (/^3[47]/.test(raw)) handleField('cardBrand', 'amex');
                            else if (/^6(?:011|5)/.test(raw)) handleField('cardBrand', 'discover');
                            else handleField('cardBrand', 'creditcard');

                        }}
                        placeholder="**** **** **** ****"
                        maxLength={form.cardBrand === 'amex' ? 18 : 19}
                        disabled={loading}
                        className="w100"
                    />
                    {form.cardBrand && (
                    <img
                        src={cardIcons[form.cardBrand]}
                        alt={form.cardBrand}
                        style={{
                        position: 'absolute',
                        right: '15px',
                        top: '5px',
                        transform: 'translateY(50%)',
                        height: '40px',
                        pointerEvents: 'none'
                        }}
                    />
                    )}                
                    <small className="fLight">Não aceitamos cartões virtuais de uso único.</small>
                    </div>
                </Grid>

                <Grid item xs={12} sm={6}>
                    {/* Nome */}
                    <div className="field" style={{ marginBottom:"0.5rem",flex: 1 }}>
                    <label>Nome impresso no cartão <span className="requiredField">*</span></label>
                    <InputText
                        value={form.cardHolderName}
                        onChange={(e) => handleField('cardHolderName', e.target.value)}
                        placeholder="Nome como impresso no cartão"
                        disabled={loading}
                        className="w100"
                    />
                    </div>
                </Grid>              


                <Grid item xs={12} sm={6}>
                    <div style={{  marginBottom:"0.5rem",flex:1 }}>
                        <label>Validade <span className="requiredField">*</span></label>
                        <InputText
                        value={form.cardExpiry}
                        onChange={(e) => {
                            const masked = maskCardExpiry(e.target.value);
                            handleField('cardExpiry', masked.value);
                        }}
                        placeholder="MM/AA"
                        maxLength={5}
                        disabled={loading}
                        className="w100"
                        />
                    </div>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <div style={{ marginBottom:"0.5rem",flex:1 }}>
                        <label>CVV <span className="requiredField">*</span></label>
                        <InputText
                        value={form.cardCvv}
                        onChange={(e) => handleField('cardCvv', e.target.value)}
                        maxLength={form.cardBrand === 'amex' ? 4 : 3}
                        placeholder="CVV"
                        disabled={loading}
                        className="w100"
                        />
                    </div>
                </Grid>                

                <Grid item xs={12} sm={6}>
                    {/* Parcelas */}
                    <div className="field" style={{flex:1 }}>
                    <label>Parcelamento <span className="requiredField">*</span></label>
                    <Dropdown
                        value={form.installments}
                        options={installmentsOptions}
                        optionLabel="label"
                        optionValue="value"
                        onChange={(e) => {
                        const opt = installmentsOptions.find(o => o.value === e.value);
                        handleField('installments', e.value);
                        handleField('installmentsLabel', opt?.label || null);
                        }}
                        disabled={loading}
                        placeholder="Selecione..."
                        className="w100"
                    />
                    </div>
                </Grid>

                <Grid item xs={12} sm={6}>
                    {/* CPF (se brasileiro) */}
                    {payer?.isForeigner !== true && (
                    <div className="field" style={{flex:1 }}>
                        <label>CPF do portador <span className="requiredField">*</span></label>
                        <InputText
                        value={payerCPF ? maskCPF(payerCPF) : form.cardHolderCpf}
                        onChange={(e) => handleField('cardHolderCpf', maskCPF(e.target.value))}
                        readOnly={!!payerCPF}
                        placeholder="000.000.000-00"
                        disabled={loading}
                        className="w100"
                        />
                        {payerCPF && <small>Preenchimento automático a partir do responsável.</small>}
                    </div>
                    )}
                </Grid>     

            </Grid>
          </TabPanel>

          <TabPanel header="PIX (em breve)" disabled>
            <div style={{ color: '#777' }}>Em breve…</div>
          </TabPanel>
        </TabView>

        {/* rodapé simples */}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'space-between', marginTop: 8, width: '100%'  }}>
          <Button
            label="Voltar"
            className="p-button-text"
            onClick={close}
            disabled={loading}
            style={{ maxWidth: "30%" }}
          />
          <Button
            label={loading ? 'Processando...' : 'Confirmar pagamento'}
            icon={loading ? 'pi pi-spin pi-spinner' : 'pi pi-check'}
            onClick={handlePay}
            disabled={loading || !form.cardNumber || !form.cardHolderName || !form.cardExpiry || !form.cardCvv || (payer?.isForeigner !== true && !form.cardHolderCpf) || !form.installments}
            style={{ maxWidth: "40%" }}
          />
        </div>
        </>
        }

      </div>
      <Toast ref={toast} position="bottom-center" />
    </Dialog>
  );
};

const mapStateToProps = (store) => ({
  dialog: store.appReducer.dialog
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...AppActions, ...OrderActions }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ReservationPayModal);
